import React from 'react'
import {Field, reduxForm} from 'redux-form'
import {connect} from 'react-redux'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight, faChevronLeft, faRedo } from '@fortawesome/free-solid-svg-icons'

let SetupForm = props => {
  const {handleSubmit, reset, submitting} = props;
  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <h5 className="long-words">{props.initialValues.widgetUrl}</h5>
          <Field className="form-control" name="widgetUrl" component="input" type="hidden"/>
        </div>
        <div className="form-group">
          <label htmlFor="merchantId">Merchant ID</label>
          <Field className="form-control" name="merchantId" component="input" type="text"/>
        </div>
        <div className="form-group">
          <label htmlFor="apiKey">Api Key</label>
          <Field className="form-control" name="apiKey" component="input" type="text"/>
        </div>
        <div className="hr-line-dashed"></div>
        <div className="form-group m-b-none">
          <div className="col-xs-12">
            <div className="col-lg-4 col-md-4 col-xs-12">
              <button type="button" className="btn btn-primary2 col-xs-12 m-b-xs" disabled={true}>
                <FontAwesomeIcon icon={faChevronLeft} />
                <span className="btn-text">Previous</span>
              </button>
            </div>
            <div className="col-lg-4 col-md-4 col-xs-12 text-center m-b-xs">
              <button type="button" className="btn btn-primary2 col-xs-12" disabled={submitting} onClick={reset}>
                <FontAwesomeIcon icon={faRedo} />
                <span className="btn-text">Reset</span>
              </button>
            </div>
            <div className="col-lg-4 col-md-4 col-xs-12 m-b-xs">
              <button type="submit" className="btn btn-primary col-xs-12" disabled={submitting}>
                <span className="btn-text">Next</span>
                <FontAwesomeIcon icon={faChevronRight} />
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  )
};

SetupForm = reduxForm({
  form: 'setup'
})(SetupForm);

SetupForm = connect(
  state => ({
    initialValues: state.app.config.environment
  })
)(SetupForm);

export default SetupForm



// WEBPACK FOOTER //
// ./src/setup/SetupForm.js